var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNybroKommun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.39,
    height: 52.2,
    viewBox: "0 0 283.39 52.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nybro-kommun-logotyp-rod",
    transform: "translate(-0.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3917",
    "data-name": "Rectangle 3917",
    width: 40.54,
    height: 27,
    transform: "translate(0.05 25.2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8834",
    "data-name": "Path 8834",
    d: "M188.61,221.83l.72-.22v.19l-7,2.93.26,2.46a6.048,6.048,0,0,1-.56.87l.52,7.12a3.13,3.13,0,0,1-1.87,0l.39-7.12c-.13-.21-.48-1-.48-1l.18-2.37-7-2.95.08-.23.74.27c2.16-1.37,2.13-4.2,6.93-4.2S186.52,220.51,188.61,221.83Zm-6.56-3c-.61.05.21,5.58.21,5.58l6.05-2.48c-2.2-1.23-3.56-3.31-6.26-3.11Zm-1.22,5.58s.84-5.46.27-5.57c-2.6-.46-4.12,1.95-6.2,3.11Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8835",
    "data-name": "Path 8835",
    d: "M206.47,221.83l.72-.22v.19l-7,2.93.27,2.46a6.265,6.265,0,0,1-.57.87l.52,7.12a3,3,0,0,1-1.87,0l.39-7.12c-.13-.2-.47-.95-.47-.95l.17-2.38-7-2.95.09-.23.74.27c2.15-1.37,2.13-4.2,6.92-4.19S204.39,220.51,206.47,221.83Zm-7.78,2.57s.84-5.46.27-5.56c-2.59-.47-4.11,1.94-6.2,3.11Zm1.22-5.57c-.6,0,.22,5.57.22,5.57l6-2.47C204,220.7,202.61,218.62,199.91,218.83Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8836",
    "data-name": "Path 8836",
    d: "M29.48,4.29v.73h-.27V4.27h-.75l.87-1.63.87,1.65Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8837",
    "data-name": "Path 8837",
    d: "M11.6,4.29v.73h-.28V4.27h-.75l.87-1.63.87,1.65Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8838",
    "data-name": "Path 8838",
    d: "M206,254.12l3.91-1.56c-.42,2-3.6,4.73-3.21,4.63S206.1,254.06,206,254.12Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8839",
    "data-name": "Path 8839",
    d: "M170.94,249h1.39a9,9,0,0,0-1,3.53,9.58,9.58,0,0,1-.39-3.53Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8840",
    "data-name": "Path 8840",
    d: "M171.24,252.56l3.75,1.68a14.919,14.919,0,0,0-.42,2.81,14.92,14.92,0,0,1-3.33-4.49Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3918",
    "data-name": "Rectangle 3918",
    width: 0.99,
    height: 1.74,
    transform: "translate(0.94 25.79)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8841",
    "data-name": "Path 8841",
    d: "M208.42,249h1.51v3.55a14.94,14.94,0,0,0-1.51-3.55Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842",
    "data-name": "Path 8842",
    d: "M207.86,243.62v1.76h-2.13a10.769,10.769,0,0,0-2.19-1.78Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8843",
    "data-name": "Path 8843",
    d: "M37.93,25.78v1.76H31.62l-.01-1.76Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8844",
    "data-name": "Path 8844",
    d: "M193.53,238.38v1.56l-1,4a12.34,12.34,0,0,0-3.92.05L187.4,240v-1.58Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8845",
    "data-name": "Path 8845",
    d: "M187.68,244.11a11.2,11.2,0,0,0-2.25.59l-1.13-3.51c1-.25,1.39-.4,2.35-.57Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8846",
    "data-name": "Path 8846",
    d: "M196.62,241.39l-1.13,3.26a6.809,6.809,0,0,0-2.14-.63l.89-3.35S195.39,241,196.62,241.39Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8847",
    "data-name": "Path 8847",
    d: "M182.26,241a17.72,17.72,0,0,0-3.92,1.8H176.5V241Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8848",
    "data-name": "Path 8848",
    d: "M204.34,242.76h-2.17a22.2,22.2,0,0,0-3.91-1.77h6.08Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8849",
    "data-name": "Path 8849",
    d: "M199.91,242.61l-1.7,3.08a17.5,17.5,0,0,0-1.94-.76l1.15-3.3A12.9,12.9,0,0,1,199.91,242.61Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8850",
    "data-name": "Path 8850",
    d: "M183.57,241.35l1.24,3.6a14.374,14.374,0,0,0-1.91.69l-1.64-3.4a9.55,9.55,0,0,1,2.31-.89Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8851",
    "data-name": "Path 8851",
    d: "M180.48,242.65l1.8,3.32a16.156,16.156,0,0,0-1.84,1l-2.24-2.9A11.49,11.49,0,0,1,180.48,242.65Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8852",
    "data-name": "Path 8852",
    d: "M203,244.5l-2.38,2.55a7,7,0,0,0-1.72-1l1.78-3.16A12.83,12.83,0,0,1,203,244.5Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8853",
    "data-name": "Path 8853",
    d: "M175,245.38h-2.1v-1.75h4.51A19.338,19.338,0,0,0,175,245.38Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8854",
    "data-name": "Path 8854",
    d: "M179.85,247.41a9.61,9.61,0,0,0-1.65,1.4l-2.9-2.37a9.239,9.239,0,0,1,2.09-1.81Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8855",
    "data-name": "Path 8855",
    d: "M203.69,245a9.939,9.939,0,0,1,1.73,1.66l-2.55,2.14-1.58-1.33Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8856",
    "data-name": "Path 8856",
    d: "M177.68,249.33a8.552,8.552,0,0,0-1.32,1.72l-3-1.92a13.141,13.141,0,0,1,1.51-2Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8857",
    "data-name": "Path 8857",
    d: "M207.47,249.15,204.62,251l-1.24-1.59,2.71-2.06a7.36,7.36,0,0,1,1.38,1.8Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8858",
    "data-name": "Path 8858",
    d: "M176,251.62a17.792,17.792,0,0,0-.8,1.8l-3-1.27a8.85,8.85,0,0,1,.79-2.31Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8859",
    "data-name": "Path 8859",
    d: "M208.82,252.05l-3,1.23a7.51,7.51,0,0,0-.83-1.82l2.94-1.58A4.91,4.91,0,0,1,208.82,252.05Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8860",
    "data-name": "Path 8860",
    d: "M30.71,25.78v1.76H24.4l-.01-1.76Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8861",
    "data-name": "Path 8861",
    d: "M9.04,25.77v1.76H2.82V25.79Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8862",
    "data-name": "Path 8862",
    d: "M16.28,25.79v1.76L9.9,27.54l-.02-1.75Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8863",
    "data-name": "Path 8863",
    d: "M38.83,25.78l1.03.01v1.74l-1.03-.01Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8864",
    "data-name": "Path 8864",
    d: "M36.42,33.7h3.45l-.02,1.8H37.93Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3919",
    "data-name": "Rectangle 3919",
    width: 4.63,
    height: 1.81,
    transform: "translate(35.22 28.37)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M38.82,31.02l1.03.01v1.74l-1.03-.01Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3920",
    "data-name": "Rectangle 3920",
    width: 0.99,
    height: 1.75,
    transform: "translate(0.94 31.03)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3921",
    "data-name": "Rectangle 3921",
    width: 4.6,
    height: 1.81,
    transform: "translate(0.94 28.37)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8866",
    "data-name": "Path 8866",
    d: "M171,246.29h3.26a23.4,23.4,0,0,0-1.56,1.81H171Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8867",
    "data-name": "Path 8867",
    d: "M.98,23.72l38.86.02.02,1.22H.98Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8868",
    "data-name": "Path 8868",
    d: "M170.12,212.6v37.87c0,8,9.32,10.38,15.49,12,2,.53,3.94,1,4.49,1.53l.42.39.39-.44c.46-.52,2.55-1.05,4.77-1.61,6-1.52,15-3.81,15-10.93V212.6Zm39.42,1.14V251.4c0,6.23-8.53,8.39-14.18,9.82a17.81,17.81,0,0,0-4.93,1.67,19.2,19.2,0,0,0-4.58-1.53c-5.82-1.52-14.63-3.82-14.63-10.89V213.74Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M242.35,232.3v12.49h-.64l-12.36-14.53v11.27c0,1.24.45,2.67,2.29,2.67v.46h-5.79v-.46c2.31-.13,2.47-1.13,2.47-2.67V229.8c-.19-1.05-1.83-1.59-2.67-1.72v-.54h4.36l11.34,13.4V232.3c-.11-3.17-.17-4.12-2.53-4.22v-.54h5.81v.56C242.06,228.18,242.46,230.2,242.35,232.3Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8870",
    "data-name": "Path 8870",
    d: "M260.74,229.85l-4.25,7.54v4.47c0,1.88.18,2.15,2,2.29a2,2,0,0,0,.19.24v.27h-6.84v-.27c.06-.08.16-.16.22-.24,1.86-.14,2.1-.35,2.1-2.27v-4.46c-1.38-2.45-2.72-4.74-4-7.06-.78-1.37-1.4-2.2-2.91-2.28v-.54h6.57v.54c-.62,0-1.7.1-1.7.88,0,1,3.23,6.17,3.82,7.16.73-1.23,3.75-5.94,3.75-7,0-.81-1-1-1.65-1v-.54h5.17v.54a3,3,0,0,0-2.47,1.73Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8871",
    "data-name": "Path 8871",
    d: "M273.31,244.66h-7.86v-.49c2-.27,2.34-.24,2.34-2.42v-11.2c0-2.23-.3-2.2-2.34-2.47v-.3c2-.22,3.71-.24,5.54-.32h1.46c2.74.1,5.62.94,5.62,3.93,0,2-1.58,3.39-3.52,4,2.72.32,4.74,2.1,4.74,4.52C279.29,243.2,276.27,244.66,273.31,244.66ZM272,228.1c-.43,0-1.21,0-1.85.06v7.09h1.4c2.61,0,4.2-1,4.2-3.58A3.46,3.46,0,0,0,272,228.1Zm0,7.86h-1.91v5.23c0,2,.21,2.82,2.37,2.82,2.72,0,4.17-1.26,4.17-3.93S274.71,236,272,236Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8872",
    "data-name": "Path 8872",
    d: "M303,247.62a7.77,7.77,0,0,1-4.36-1.08c-3.39-2-6.3-6.46-9.34-9.61h-2.29v4.69c0,2,.19,2.58,1.94,2.58h.43v.46h-6.89v-.46h.27c1.78,0,2-.54,2-2.34V230.39c0-1.75-.21-2.23-2-2.23h-.3v-.65h5.2c3.47,0,7.56.41,7.56,4.34a4.91,4.91,0,0,1-3.55,4.6,39.881,39.881,0,0,1,3,3.26,43.88,43.88,0,0,0,4.49,5,10.1,10.1,0,0,0,4.63,2.53v.38Zm-10.28-15.86c-.14-2.8-1.91-3.63-4.5-3.63h-1.21v8.07a.83.83,0,0,0,.27,0c3.23,0,5.44-.43,5.44-4.2Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8873",
    "data-name": "Path 8873",
    d: "M309.24,227.19a8.62,8.62,0,0,1,8.78,8.56,9.08,9.08,0,0,1-9.1,9.28,8.71,8.71,0,0,1-8.86-8.74,8.92,8.92,0,0,1,9.18-9.1Zm-6.51,8.32c0,4,1.8,8.77,6.54,8.77,4.36,0,6.06-3.93,6.06-7.91s-1.75-8.46-6.44-8.46c-4.09,0-6.16,3.37-6.16,7.6Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8874",
    "data-name": "Path 8874",
    d: "M348.66,247.24v.38h-.83a7.76,7.76,0,0,1-4.36-1.08c-3.61-2.18-6.81-7.1-10-10.31l-.38.35c-.05,4.93-.05,5-.05,5.2,0,1.77.11,2.31,2.26,2.39v.49h-6.59v-.49c1.8-.1,2-.37,2-2.37V229.69c-.11-1.64-1.05-1.61-2.18-1.61v-.54h6.52v.54c-1.57.1-2,.43-2.08,1.56v5.84c2.13-2,6.38-5.41,6.38-6.73,0-.38-.46-.67-1-.67v-.54h4.74v.54a5.38,5.38,0,0,0-2.29,1.26c-1.91,1.83-3.77,3.53-5.63,5.38,3,3.07,5.63,7.25,8.83,10a10.1,10.1,0,0,0,4.66,2.52Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8875",
    "data-name": "Path 8875",
    d: "M354.18,227.19a8.62,8.62,0,0,1,8.77,8.56,9.07,9.07,0,0,1-9.1,9.28,8.7,8.7,0,0,1-8.85-8.74,8.92,8.92,0,0,1,9.18-9.1Zm-6.52,8.32c0,4,1.81,8.77,6.55,8.77,4.36,0,6.05-3.93,6.05-7.91s-1.75-8.46-6.43-8.46c-4.09,0-6.17,3.37-6.17,7.6Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8876",
    "data-name": "Path 8876",
    d: "M386.51,228.08h-.08c-2.05,0-2.21,1.26-2.21,3.66l-.16,10.63c.1,1.32.53,1.64,2.18,1.8v.49h-6.73v-.49a2,2,0,0,0,2.21-1.85l.24-11.87-6.57,14.31h-.49l-6.54-13.94c0,3.69-.1,7.7-.1,11.2,0,1.67.75,1.83,2.31,2.18v.46h-5.73v-.46c2.31-.16,2.39-1.51,2.39-4.31s.14-5.73.14-8.45a3.08,3.08,0,0,0-2.53-3.36v-.54h4.52l6.46,13.78,6.41-13.78h4.28Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8877",
    "data-name": "Path 8877",
    d: "M411.3,228.08h-.08c-2.05,0-2.21,1.26-2.21,3.66l-.16,10.63c.11,1.32.54,1.64,2.18,1.8v.49H404.3v-.49a2,2,0,0,0,2.21-1.85l.24-11.87-6.57,14.31h-.48l-6.55-13.94c0,3.69-.1,7.7-.1,11.2,0,1.67.75,1.83,2.31,2.18v.46h-5.73v-.46c2.31-.16,2.4-1.51,2.4-4.31s.13-5.73.13-8.45a3.08,3.08,0,0,0-2.53-3.36v-.54h4.52l6.46,13.78L407,227.54h4.28Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8878",
    "data-name": "Path 8878",
    d: "M430,232.17v3.36c0,5.71-.4,9.48-7.1,9.48-5.84,0-6.95-3.45-6.95-8.59v-4c0-3.58.16-4.2-2-4.36h-.08v-.54h6.59v.54a2.014,2.014,0,0,0-1.64.51c-.48.56-.48,2.72-.48,3.66v6.11c0,3.26,1.37,5.57,5,5.57,3.26,0,5.17-2,5.17-5.28V231.1c0-1.43-.65-3-2.31-3v-.54h6v.54C430.21,228.18,430,229.42,430,232.17Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8879",
    "data-name": "Path 8879",
    d: "M451.23,232.3v12.49h-.65l-12.36-14.53v11.27c0,1.24.46,2.67,2.29,2.67v.46h-5.79v-.46c2.32-.13,2.48-1.13,2.48-2.67V229.8c-.19-1.05-1.83-1.59-2.66-1.72v-.54h4.36l11.33,13.4V232.3c-.11-3.17-.16-4.12-2.53-4.22v-.54h5.81v.56C450.93,228.18,451.34,230.2,451.23,232.3Z",
    transform: "translate(-170.08 -212.6)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNybroKommun);
export default __webpack_public_path__ + "static/media/logo-nybro-kommun.b3550253825ad01b95d4d8b5800f8609.svg";
export { ForwardRef as ReactComponent };